import './stories';
import './overlay';
import './slick';
import 'bs5-lightbox';
import $ from 'jquery';

$(document).ready(function () {
  import('bootstrap/js/dist/tab').then();

  function loadPhotoSwipeLightbox(doSomething) {
    Promise.all([import('photoswipe'), import('photoswipe/lightbox')]).then(
      ([PhotoSwipe, PhotoSwipeLightbox]) => {
        doSomething?.(PhotoSwipe.default, PhotoSwipeLightbox.default);
      },
    );
  }

  this.querySelector('.profile-section').classList.remove('visibility-hidden');

  Sceon.Stories.init({
    profile_id: window.Escort.ref_id,
  });

  function parseHash() {
    let hash = document.location.hash.substring(1);

    if (!hash.length) {
      return {};
    }

    let params = hash.split(';');

    let allowedParamNames = {
      from: {
        is_array: false,
        name: 'from',
      },
      page: {
        is_array: false,
        name: 'page',
      },
      sort: {
        is_array: false,
        name: 'sort',
      },
      reg: {
        is_array: false,
        name: 'reg',
      },
      name: {
        is_array: false,
        name: 'name',
      },
      video: {
        is_array: false,
        name: 'video',
      },
      has_nat_pic: {
        is_array: false,
        name: 'has_nat_pic',
      },
      s: {
        is_array: true,
        name: 's',
      },
      af: {
        is_array: true,
        name: 'af',
      },
      sf: {
        is_array: true,
        name: 'sf',
      },
      cs: {
        is_array: true,
        name: 'cs',
      },
      a: {
        is_array: true,
        name: 'a',
      },
      l: {
        is_array: true,
        name: 'l',
      },
      n: {
        is_array: true,
        name: 'n',
      },
      hc: {
        is_array: true,
        name: 'hc',
      },
      hl: {
        is_array: true,
        name: 'hl',
      },
      h: {
        is_array: true,
        name: 'h',
      },
      w: {
        is_array: true,
        name: 'w',
      },
      ec: {
        is_array: true,
        name: 'ec',
      },
      sm: {
        is_array: true,
        name: 'sm',
      },
      e: {
        is_array: true,
        name: 'e',
      },
    };

    let filterData = {};
    params.map(function (param) {
      let key_value = param.split('=');

      let key = key_value[0];
      let val = key_value[1];

      if (!val) {
        return;
      }
      if (!allowedParamNames[key]) {
        return;
      }
      val = val.split(',');
      val.map(function (it) {
        if (allowedParamNames[key].is_array) {
          filterData[allowedParamNames[key].name] =
            filterData[allowedParamNames[key].name] || [];
          filterData[allowedParamNames[key].name].push(it);
        } else {
          filterData[allowedParamNames[key].name] = it;
        }
      });
    });

    return filterData;
  }

  const filters = parseHash();
  if (Object.values(filters).length) {
    let url = Sceon.ProfilePaging.url;

    let pid = window.Escort.ref_id;
    $.ajax({
      url: url,
      method: 'GET',
      data: {
        ...filters,
        pid: pid,
      },
      success: function (resp) {
        if (resp) {
          if (resp.previous_id && resp.previous_id === +pid) {
            $('#btn-next').addClass('hidden').attr('data-href', '');
            $('#btn-previous').addClass('hidden').attr('data-href', '');
            return;
          }
          if (resp.next_id) {
            $('#btn-next')
              .removeClass('hidden')
              .attr(
                'data-href',
                `/sex-model/${resp.next_showname}-${resp.next_id}`,
              );
          } else {
            $('#btn-next').addClass('hidden').attr('data-href', '');
          }
          if (resp.previous_id) {
            $('#btn-previous')
              .removeClass('hidden')
              .attr(
                'data-href',
                `/sex-model/${resp.previous_showname}-${resp.previous_id}`,
              );
          } else {
            $('#btn-previous').addClass('hidden').attr('data-href', '');
          }

          if (resp.next_id || resp.previous_id) {
            $('#next-prev').removeClass('hidden');
          }
        }
      },
    });
  }

  function profilePageViewGA(name) {
    let href = $(this).attr('data-href');
    let hash = document.location.hash.substring(1);
    if (!href || href === '') {
      return;
    }

    new Promise((resolve) => {
      ga('send', 'event', 'profilepage', name, {
        hitCallback: resolve,
      });

      setTimeout(resolve, 1000);
    }).then(() => {
      location.href = `${href}#${hash}`;
    });
  }

  $('#btn-next').click(function () {
    profilePageViewGA.call(this, 'nextbtn_tap');
  });
  $('#btn-previous').click(function () {
    profilePageViewGA.call(this, 'backbtn_tap');
  });

  $('.show-more-photos').click(function () {
    $(this).parent().find('.more-photos').removeAttr('hidden');
    $(this).remove();
  });

  function initTabClick() {
    if (window.innerWidth > 1024) {
      function updateHeight() {
        const element = $(tabsElement).find('.tab-content');
        let height = 0;
        element.children().each((ind, el) => {
          height += $(el).outerHeight();
        });
        let tab = $('#profile-tabs .nav-link.active').data('bs-target');

        if (tab === '#tab-photos') {
          $('#pills-bio-tab').trigger('click');
          tab = '#tab-bio';
        }

        let top = 4;
        $('.profile-tab').each(function (ind, el) {
          if ($(el).attr('id') === tab.substring(1)) {
            return false;
          }
          top += $(el).outerHeight(true);
        });

        requestAnimationFrame(() => {
          $(document)
            .find('.profile-tab')
            .css({
              '-webkit-transform': 'translate(0, -' + top + 'px)',
              transform: 'translate(0, -' + top + 'px)',
            });

          element.css({
            height: `${height - top}px`,
          });
        });
      }

      $('#profile-tabs .profile-tab-link')
        .unbind('click')
        .click(function (e) {
          e.stopPropagation();
          updateHeight();
        });

      const ro = new ResizeObserver(() => updateHeight());
      const commentsTab = $('#tab-comments')[0];

      if (commentsTab) {
        ro.observe(commentsTab);
      }
    }
  }

  const tabsElement = $('#profile-tabs');

  document
    .querySelectorAll('#profile-tabs button[data-bs-toggle="pill"]')
    .forEach((elm) => {
      elm.addEventListener('shown.bs.tab', () => {
        initTabClick();
      });
    });

  initTabClick();
  $(window).resize(() => {
    // initTabClick();
    if (window.innerWidth > 1024) {
      let tab = $('#profile-tabs .nav-link.active').data('bs-target');
      let top = 4;

      $('.profile-tab').each(function (ind, el) {
        if ($(el).attr('id') === tab.substring(1)) {
          return false;
        }
        top += $(el).outerHeight(true);
      });
      $(document)
        .find('.profile-tab')
        .css({ '-webkit-transform': 'translate(0, -' + top + 'px)' });
    }
  });

  function initMap(map_location) {
    const location_lat = map_location.latitude;
    const location_lng = map_location.longitude;

    const mapProp = {
      center: new google.maps.LatLng(location_lat, location_lng),
      fullscreenControl: false,
      zoom: 15,
    };
    const map = new google.maps.Map(
      document.getElementById('profile-map'),
      mapProp,
    );
    const lng_lat = {
      lat: +location_lat,
      lng: +location_lng,
    };

    map.setCenter(lng_lat);

    const marker = new google.maps.Marker({
      map: map,
      position: lng_lat,
    });
  }

  document
    .querySelector('#enter-map button')
    ?.addEventListener('click', function () {
      const map_location = $(this).data('location');

      if (
        map_location?.is_visible &&
        map_location.latitude &&
        map_location.longitude
      ) {
        const google_api = `https://maps.googleapis.com/maps/api/js?key=${envConfigs.google_api_key}&sensor=false`;
        const scriptTag = document.createElement('script');
        scriptTag.src = google_api;
        scriptTag.id = 'gmapscript';
        document.body.appendChild(scriptTag);

        document.getElementById('gmapscript').addEventListener('load', () => {
          initMap(map_location);
          document.getElementById('enter-map').remove();
          initTabClick();
        });
      }
    });

  $('.report-problem, .tell-friend, .report-fake, .alert-me, .write-me').click(
    function () {
      event.preventDefault();
      let url = $(this).attr('rel');

      if (url) {
        Sceon.RPopup.Show(url);
      }
    },
  );

  $('.open-signup-popup').click(function (e) {
    e.preventDefault();
    Sceon.Popup.Show();
  });

  $('.add-to-favorites').click(function (e) {
    e.preventDefault();
    let fav_id =
      $(this).attr('data-fav') && $(this).attr('data-fav') != 'null'
        ? $(this).attr('data-fav')
        : window.Escort.escort_id;
    let url = $(this).attr('data-href');
    let alt_url = $(this).attr('data-alt-href');
    let fav_overlay = new Sceon.Overlay($('.add-to-favorites'), {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0, left: '1px' },
    });
    fav_overlay.enable();
    $.ajax({
      url: url,
      method: 'POST',
      data: {
        id: fav_id,
      },
      success: function (resp) {
        if (resp.status == 'success') {
          $('.add-to-favorites').attr({
            'data-href': alt_url,
            'data-alt-href': url,
          });

          if (resp.id) {
            $('.add-to-favorites').attr('data-fav', resp.id);
          } else {
            $('.add-to-favorites').attr('data-fav', 'null');
          }
          $('.add-to-favorites').toggleClass('action-active');
        }
        $('.add-to-favorites .overlay').remove();
        $('body').removeClass('overflow-hidden');
      },
    });
  });

  $('.gallery-tab-desktop .link-button').click(function () {
    $(this).attr('hidden', 'hidden');
    $('.gallery-tab-desktop .more-photos').removeAttr('hidden');
  });

  loadPhotoSwipeLightbox((PhotoSwipe, PhotoSwipeLightbox) => {
    $('.gallery-tab-desktop a:not(.link-button)').click(function (e) {
      e.preventDefault();
      let index = $(this)
        .closest('.gallery-tab-desktop')
        .find('a:not(.link-button)')
        .index(this);
      let options = {
        index,
        dataSource: [],
        imageClickAction: 'zoom',
        allowUserZoom: false,
        zoomEl: false,
        maxSpreadZoom: 1,
        pswpModule: PhotoSwipe,
        getDoubleTapZoom: function (isMouseClick, item) {
          return item.initialZoomLevel;
        },
        pinchToClose: false,
      };
      $(this)
        .closest('.gallery-tab-desktop')
        .find('a:not(.link-button) img')
        .each(function (ind, el) {
          let src = $(el).attr('src').replace('profile_s', 'profile');
          let width = $(el).attr('data-width');
          let height = $(el).attr('data-height');
          options.dataSource.push({
            src,
            alt: '',
            width,
            height,
          });
        });
      const pswp = new PhotoSwipeLightbox(options);
      pswp.init();
      pswp.loadAndOpen(index);
    });
    $(
      '.gallery-carousel div:not(.next-arrow, .prev-arrow, .slick-cloned)',
    ).click(function (e) {
      e.stopPropagation();
      let index = $(this)
        .closest('.gallery-carousel')
        .find('div.slick-slide:not(.slick-cloned)')
        .index(this);
      const leftArrowSVGString = `<i class="sc-and6 sc-and6-chevron-right text-white"></i>`;
      const rightArrowSVGString = `<i class="sc-and6 sc-and6-chevron-left text-white"></i>`;
      let options = {
        index,
        arrowPrevSVG: rightArrowSVGString,
        arrowNextSVG: leftArrowSVGString,
        dataSource: [],
        pswpModule: PhotoSwipe,
        wheelToZoom: true,
        tapAction: 'zoom',
        doubleTapAction: false,
        showHideAnimationType: 'none',
      };

      $(this)
        .closest('.gallery-carousel')
        .find('div.slick-slide:not(.slick-cloned) img')
        .each(function (ind, el) {
          let src = $(el)
            .attr('src')
            .replace('profile_s', 'profile')
            .replace('thumb_560', 'profile');
          let width = $(el).attr('data-width');
          let height = $(el).attr('data-height');
          options.dataSource.push({
            src,
            alt: '',
            width,
            height,
          });
        });

      const pswp = new PhotoSwipeLightbox(options);
      pswp.init();
      pswp.loadAndOpen(index);
      pswp.on('close', () => {
        $(this)
          .closest('.gallery-carousel')
          .slick('slickGoTo', +pswp.pswp.currIndex);
      });
    });
  });
  //Video
  $('.video-cover').click(function () {
    $('.video-cover').addClass('hidden');
    $('.video-modal').removeClass('hidden');

    if ($('.video-modal').length) {
      $(this).parent().find('.video-element video')[0].play();
    }
  });

  $(window).resize(function () {
    if ($('.video-modal').length) {
      $('.video-modal video').each((index, elm) => {
        if (elm.currentTime) {
          elm.pause();
          elm.currentTime = 0;
        }
      });
    }
  });
  //END Video

  //Company Slick
  if ($('.profile-ag-container').length) {
    $('.agency-escorts-list .escorts-list').slick({
      speed: 100,
      infinite: false,
      variableWidth: true,
      draggable: false,
      waitForAnimate: false,
      cssEase: 'linear',
      prevArrow:
        '<i class="sc-and6 sc-and6-chevron-left text-bold text-white prev-arrow fs-18"></i>',
      nextArrow:
        '<i class="sc-and6 sc-and6-chevron-right text-bold text-white next-arrow fs-18"></i>',
    });
  }
  //END Company Slick

  //Call From Mobile
  $('.call-from-mobile').on('click', function () {
    $.ajax({
      url: '/callfrom',
      method: 'POST',
      data: {
        profile_id: profileData.escortId,
        account_id: profileData.accountId,
      },
    });
  });
  //End Call From Mobile

  //Call From Whatsapp
  $('.whatsapp').on('click', function () {
    $.ajax({
      url: '/callfromwhatsapp',
      method: 'POST',
      data: {
        profile_id: profileData.escortId,
        account_id: profileData.accountId,
      },
    });
  });
  //End Call From Whatsapp
});
